import { graphqlDynamic } from "react-apollo-dynamic-query"
import gql from "graphql-tag"
import ExcludedAreasTable from "../ExcludedAreas/ExcludedAreasTable"
import { connect } from "react-redux"
import { createMatchSelector } from "react-router-redux"
import routes from "../../routes"

const generateQuery = ({ entityType }) => {
  const unitsQuery = gql`
    fragment UnitsQuery on Facility {
      units {
        id
        name
        excludeFromCompliance
        excludedLocations: locations(excludeFromCompliance: true) {
          id
          name
        }
      }
    }
  `

  switch (entityType) {
    case "facility":
      return gql`
        query ExcludedAreasTable($entityId: ID!) {
          entity: facility(id: $entityId) {
            id
            ...UnitsQuery
          }
        }
        ${unitsQuery}
      `
    case "department":
      return gql`
        query ExcludedAreasTable($entityId: ID!) {
          entity: department(id: $entityId) {
            id
            facility {
              id
              ...UnitsQuery
            }
          }
        }
        ${unitsQuery}
      `
    /* istanbul ignore next */
    default:
      throw Error(`Invalid entityType: ${entityType}`)
  }
}

const ExcludedAreasTableWithApollo = graphqlDynamic(generateQuery, {
  options: ({ entityId }) => ({
    variables: {
      entityId,
    },
  }),
  props: ({ data: { loading, error, entity } }) => {
    if (error) {
      throw error
    }
    if (!loading) {
      if (!entity) {
        throw Error("404")
      }

      if (entity.facility) {
        entity = entity.facility
      }

      return {
        units: entity.units,
      }
    }
    return { loading, units: [] }
  },
})(ExcludedAreasTable)

const ExcludedAreasTableWithData = connect(({ router }) => {
  // This is a partial match for many of our routes, but the intent is to get the top-level entity.
  const match = createMatchSelector(routes.entity)({ router })
  return {
    location: router.location,
    entityType: match.params.entityType,
    entityId: match.params.entityId,
  }
})(ExcludedAreasTableWithApollo)

export default ExcludedAreasTableWithData
